var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "header" }, [
        _c("i", { staticClass: "fa fa-comments" }),
        _vm._v(" "),
        _c("h5", { staticClass: "d-inline mx-2" }, [
          _vm._v(_vm._s(_vm.$t("txtAddCommentInfo")))
        ])
      ]),
      _vm._v(" "),
      !_vm.readonly
        ? [
            _c("textarea", {
              directives: [
                { name: "autogrow", rawName: "v-autogrow" },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newComment,
                  expression: "newComment"
                }
              ],
              staticClass: "add_comment mb-1",
              attrs: {
                id: "commentbox_" + _vm.card.id,
                rows: "1",
                placeholder: _vm.$t("txtAddComment")
              },
              domProps: { value: _vm.newComment },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.newComment = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("TextSuggest", {
              attrs: {
                textBoxId: "commentbox_" + _vm.card.id,
                suggestions: _vm.userEmails,
                trigger: "@"
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default btn-outline-secondary",
                on: { click: _vm.commentCreate }
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("btnSend")) + "\n    ")]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        _vm._l(_vm.card.comments, function(comment) {
          return _c("Comment", {
            key: comment.id,
            attrs: {
              comment: comment,
              readonly: _vm.readonly,
              lockeddown: _vm.lockeddown,
              userEmails: _vm.userEmails
            },
            on: {
              "comment-delete": _vm.commentDelete,
              "comment-save": _vm.commentSave,
              "reply-delete": _vm.replyDelete,
              "reply-save": _vm.replySave,
              "reply-create": _vm.replyCreate
            }
          })
        }),
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }